import type { AchievementDef } from "@highmarch/domain";
import { btnHtml } from "../kit";
import { medalHtml, medalTier } from "./achievementsSheet";

/** How long the banner stays up untouched (ms): long enough to read the name and reach CLAIM. */
export const BANNER_MS = 5200;
/** The drop-in starts a frame after insertion so the transition runs; the fade-out's length before removal. */
const SHOW_DELAY_MS = 20, HIDE_MS = 350;
/** Medallion size on the banner. */
const MEDAL_PX = 50;

/**
 * "Achievement unlocked" (FINISH_PLAN WP7): a gold-framed plate that drops in under the hub's top bar when one or more
 * achievements are newly done — the first one's name, how many more, and CLAIM, which opens the Achievements sheet (as
 * does a tap anywhere on it). One at a time; it closes itself after BANNER_MS.
 */
export function showAchievementBanner(parent: HTMLElement, done: readonly AchievementDef[], onOpen: () => void): { dismiss(): void } {
  parent.querySelector(".achbanner")?.remove();
  const first = done[0];
  const el = document.createElement("div");
  el.className = "achbanner";
  el.setAttribute("role", "status");
  const more = done.length > 1 ? `+${done.length - 1} more · ` : "";
  el.innerHTML = `${medalHtml("ready", MEDAL_PX, medalTier(first))}<div class="tx"><small class="disp">ACHIEVEMENT UNLOCKED</small><b class="disp">${first.name}</b><span>${more}${first.description}</span></div>${btnHtml("CLAIM", "gold", { className: "go" })}`;
  let closed = false;
  const dismiss = (): void => {
    if (closed) return;
    closed = true;
    window.clearTimeout(timer);
    el.classList.remove("show");
    window.setTimeout(() => el.remove(), HIDE_MS);
  };
  el.addEventListener("click", () => { dismiss(); onOpen(); });
  parent.append(el);
  window.setTimeout(() => el.classList.add("show"), SHOW_DELAY_MS);
  const timer = window.setTimeout(dismiss, BANNER_MS);
  return { dismiss };
}
